import { Teksten } from "../../../content";
import { useAppDispatch } from "../../../store/hooks";
import { unpublish } from "../../../store/reducers/dossier-metadata";
import { IconLabelMolecule } from "../icon-label";
import { PopupMolecule } from "../popup";

interface Props {
  depublicerenId: string;
  close: () => void;
}

export function PopupDepublicerenDossierMolecule(props: Readonly<Props>) {
  const dispatch = useAppDispatch();

  const alert = () => {
    return <IconLabelMolecule icon={"icon-alert-blue"} label={Teksten.intrekken.dossier.warning} type={"default"} />;
  };

  return (
    <PopupMolecule
      title={Teksten.intrekken.dossier.title}
      text={Teksten.intrekken.dossier.tekst}
      cancelButton={{
        text: "Annuleren",
        onClick: () => {
          props.close();
        },
      }}
      okeButton={{
        text: "Dossier intrekken",
        onClick: () => {
          dispatch(unpublish({ id: props.depublicerenId }));
          props.close();
        },
      }}
      extraInfo={alert()}
    />
  );
}
